export default __webpack_public_path__ + "static/media/619.e2f00078.png";